import { useState, useEffect } from 'react';

export function useLocalStorageState(key, defaultValue) {
  // 1. Initialize state from localStorage or the default value
  const [value, setValue] = useState(() => {
    const storedValue = localStorage.getItem(key);
    return storedValue !== null ? JSON.parse(storedValue) : defaultValue;
  });

  // 2. Use useEffect to save to localStorage whenever the state changes
  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  return [value, setValue];
}